/*
 * @Author: Dom
 * @Date: 2022-07-20 16:56:39
 * @LastEditTime: 2022-07-20 17:32:21
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\services\currency.ts
 */
import request from '@/utils/request'

//查询币种类型列表
export async function getCurrencyType(params?:any): Promise<any>{
    return request({
        url: '/seller/v1/currencyCode/listInfo',
        method: 'POST',
        data: params
    })
}

//查询日期有效的币种兑换汇率详情
export async function getCurrencyDetail(params?:any): Promise<any>{
    return request({
        url: '/seller/v1/currencyExchange/validInfo',
        method: 'POST',
        data: params
    })
}
